import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export const getCatchReportPeriodsAdmin = async (params: any = {}) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/CatchReport/periods-admin${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
